import Main from './Main.vue'
import Eventos from './components/Eventos.vue'
import Visualizar from './components/Visualizar'
import Evento from './components/Evento'

export default [{
  path: 'eventos',
  component: Main,
  children: [
    {path: '/', component: Eventos, name: 'eventos'},
    {path: 'registro', component: Evento, name: 'evento.novo'},
    {path: ':id', component: Visualizar, name: 'eventos.visualizar'},
    {path: ':id/edit', component: Evento, name: 'evento.editar'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/eventos/routes.js